import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { formatDistance } from "@/lib/radar";
import { useOverlayLock } from "@/contexts/UiOverlayContext";

export default function MatchDetailsDialog({ open, onOpenChange, match }) {
  useOverlayLock(open);
  if (!match) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="match-details-dialog"
        className="bg-[#0A0A0A] border-white/10 text-white max-w-md"
      >
        <DialogHeader>
          <DialogTitle className="font-display text-xl flex items-center gap-3">
            <Avatar name={match.display_name} />
            <span>{match.display_name}</span>
          </DialogTitle>
          <DialogDescription className="text-[#A1A1AA] font-body text-xs uppercase tracking-wider">
            {formatDistance(match.distance_meters)} away
          </DialogDescription>
        </DialogHeader>

        <section className="space-y-5 pt-2">
          <div>
            <p className="text-[#A1A1AA] text-xs uppercase tracking-wider font-body mb-2">
              You give → ({match.give_count})
            </p>
            <ChipRow numbers={match.give} variant="solid" testid={`details-give-${match.user_id}`} />
          </div>
          <div>
            <p className="text-[#A1A1AA] text-xs uppercase tracking-wider font-body mb-2">
              You get ← ({match.get_count})
            </p>
            <ChipRow numbers={match.get} variant="outline" testid={`details-get-${match.user_id}`} />
          </div>
        </section>

        <p className="text-[10px] text-[#A1A1AA]/60 font-body pt-3 border-t border-white/5">
          Only approximate distance and display name are shown. Exact location stays private.
        </p>
      </DialogContent>
    </Dialog>
  );
}

function Avatar({ name }) {
  const initial = (name || "?").charAt(0).toUpperCase();
  return (
    <span className="h-8 w-8 rounded-full bg-gradient-to-br from-[#E5B83A] to-[#C9971C] text-black font-bold text-sm flex items-center justify-center shrink-0">
      {initial}
    </span>
  );
}

function ChipRow({ numbers, variant, testid }) {
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testid}>
      {numbers.map((n) => (
        <span
          key={n}
          className={
            "h-7 min-w-[28px] px-2 rounded-md flex items-center justify-center text-xs font-medium font-body border " +
            (variant === "solid"
              ? "bg-[#E5B83A] text-black border-[#E5B83A]"
              : "bg-transparent text-[#E5B83A] border-[#E5B83A]")
          }
        >
          {n}
        </span>
      ))}
    </div>
  );
}
